import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

const FALLBACK = "https://via.placeholder.com/120x120?text=Item";

const getCart = () => {
  try {
    return JSON.parse(localStorage.getItem("dz_cart") || "[]");
  } catch {
    return [];
  }
};
const setCart = (items) =>
  localStorage.setItem("dz_cart", JSON.stringify(items));

export default function CartPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(getCart());
  }, []);

  const save = (next) => {
    setItems(next);
    setCart(next);
  };

  const updateQty = (key, qty) => {
    const q = Number(qty);
    if (q <= 0) return removeItem(key);
    const next = items.map((it) => (it.key === key ? { ...it, qty: q } : it));
    save(next);
  };

  const removeItem = (key) => {
    const next = items.filter((it) => it.key !== key);
    save(next);
  };

  const clearCart = () => save([]);

  const subTotal = useMemo(
    () => items.reduce((a, it) => a + (it.unitPrice || 0) * (it.qty || 0), 0),
    [items]
  );
  const advance = Math.round(subTotal * 0.1 * 100) / 100; // 10%
  const remaining = Math.max(subTotal - advance, 0);

  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <meta name="robots" content="noindex, nofollow" />
      {/* Top bar */}
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => navigate(-1)} className="px-3 py-1.5 border rounded-lg hover:bg-gray-50">
          ← Back
        </button>
        <button onClick={() => navigate("/store")} className="px-3 py-1.5 border rounded-lg hover:bg-gray-50">
          🏪 Continue shopping
        </button>
      </div>

      <h1 className="text-2xl font-extrabold mb-4">Your Cart</h1>

      {items.length === 0 ? (
        <div className="text-gray-600">
          Cart is empty.{" "}
          <button className="text-green-600 underline" onClick={() => navigate("/store")}>
            Go to Store
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Items */}
          <div className="lg:col-span-2 space-y-3">
            {items.map((it) => (
              <div key={it.key} className="flex items-center gap-4 bg-white border rounded-xl p-3">
                <div className="w-20 h-20 rounded-lg bg-gray-100 overflow-hidden flex-shrink-0">
                  <img
                    src={it.image || FALLBACK}
                    alt={it.title}
                    className="w-full h-full object-cover"
                    onError={(e) => (e.currentTarget.src = FALLBACK)}
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="font-semibold line-clamp-1">{it.title}</div>
                  <div className="text-xs text-gray-500">
                    {it.category} • {it.color}
                  </div>

                  <div className="mt-2 flex items-center gap-3">
                    <span className="font-bold">₹{it.unitPrice}</span>
                    <div className="flex items-center gap-1">
                      <label className="text-xs text-gray-500">Qty:</label>
                      <select
                        className="border rounded px-2 py-1 text-sm"
                        value={it.qty}
                        onChange={(e) => updateQty(it.key, e.target.value)}
                      >
                        {Array.from({ length: 100 }, (_, i) => i + 1).map((n) => (
                          <option key={n} value={n}>
                            {n}
                          </option>
                        ))}
                      </select>
                    </div>
                    <button
                      className="text-red-600 text-sm underline"
                      onClick={() => removeItem(it.key)}
                    >
                      Remove
                    </button>
                  </div>
                </div>

                <div className="font-semibold">₹{(it.unitPrice || 0) * (it.qty || 0)}</div>
              </div>
            ))}

            <button className="text-sm text-gray-600 underline" onClick={clearCart}>
              Clear cart
            </button>
          </div>

          {/* Summary */}
          <aside className="bg-white border rounded-xl p-4 h-fit sticky top-24">
            <h2 className="font-semibold mb-3">Order Summary</h2>
            <div className="flex justify-between py-1">
              <span>Subtotal</span>
              <span>₹{subTotal}</span>
            </div>
            <div className="flex justify-between py-1">
              <span>Advance (10%)</span>
              <span className="text-green-700 font-semibold">₹{advance}</span>
            </div>
            <div className="flex justify-between py-1">
              <span>Pay on Delivery</span>
              <span>₹{remaining}</span>
            </div>

            <button
              className="mt-4 w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg"
              onClick={() => navigate("/checkout")}
            >
              Proceed to Checkout
            </button>

            <p className="text-xs text-gray-500 mt-2">
              Checkout par 10% online collect hoga, baaki amount delivery pe COD.
            </p>
          </aside>
        </div>
      )}
    </div>
  );
}
